<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 23" style="height: auto">
    <path
      d="M17 4.12723L7.36727 19.5L2 14.505L2.73091 13.6497L7.14909 17.7666L16.0836 3.5L17 4.12723Z"
      :class="colorClass"
    />
    <path
      d="M20.9888 4.12723L11.0674 19.5L9 17.9718L9.57303 16.9911L10.8315 17.7666L20.0562 3.5L21 4.12723H20.9888Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
